import Footer from "./Footer";
import Navbar from "./Navbar";


export const Products = () => (
<>
<Navbar />
<section className="bg-gray-100 px-6 py-28 text-center">
<h1 className="text-5xl font-extrabold">Our Turf Products & Systems</h1>
<p className="text-xl max-w-3xl mx-auto mt-6">
Explore high-performance turf systems engineered for players, durability and long-term usage.
</p>
</section>


<section className="container mx-auto px-6 py-20 space-y-16">
<article>
<h2 className="text-4xl font-bold">Football Turf Systems</h2>
<p className="mt-4 text-lg">
50mm–60mm monofilament turf with silica sand + SBR or EPDM infill. FIFA-certified options available.
</p>
</article>


<article>
<h2 className="text-4xl font-bold">Box Cricket Turf</h2>
<p className="mt-4 text-lg">High-bounce, durable, non-slip cricket turf suitable for all formats.</p>
</article>


<article>
<h2 className="text-4xl font-bold">Multi-Sport Turf</h2>
<p className="mt-4 text-lg">Designed for tennis, volleyball, basketball and multi-skill training zones.</p>
</article>


<article>
<h2 className="text-4xl font-bold">Accessories & Add-ons</h2>
<ul className="list-disc pl-6 mt-4 text-lg space-y-2">
<li>Shockpads & Underlays</li>
<li>Drainage Pipes</li>
<li>Fencing & Poles</li>
<li>Sports Lighting</li>
</ul>
</article>
</section>
<Footer />
</>
);